import { useMantineColorScheme } from '@mantine/core'

export function ThemeToggle() {
  const { colorScheme, setColorScheme } = useMantineColorScheme()
  const isDark = colorScheme === 'dark'

  function toggle() {
    setColorScheme(isDark ? 'light' : 'dark')
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
      aria-pressed={isDark}
      data-testid="theme-toggle"
      title={isDark ? 'Tema claro' : 'Tema escuro'}
      style={{
        background: 'transparent',
        border: 'none',
        fontSize: '1.25rem',
        cursor: 'pointer',
        padding: '4px 8px',
        borderRadius: 'var(--radius-sm, 6px)',
        color: 'var(--text-primary)',
        lineHeight: 1,
      }}
    >
      <span aria-hidden="true">{isDark ? '☀️' : '🌙'}</span>
    </button>
  )
}
